import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CountryAutocomplete from './CountryAutocomplete';
import { saveUser } from '../utils/storageUtils';
import { useTheme } from '../context/ThemeContext';
import ThemeToggle from './ThemeToggle';
import '../styles/Login.css';

const Login = ({ onUserLogin }) => {
  const [country, setCountry] = useState('');
  const [twitterUsername, setTwitterUsername] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { theme } = useTheme();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Basic validation
    if (!country) {
      setError('Please select a country.');
      return;
    }
    
    if (!twitterUsername) {
      setError('Please enter your Twitter username.');
      return;
    }
    
    // Remove @ symbol if present
    const cleanUsername = twitterUsername.startsWith('@') 
      ? twitterUsername.substring(1) 
      : twitterUsername;
    
    setLoading(true);
    
    try {
      // Save user data locally
      const userData = {
        country,
        twitterUsername: cleanUsername,
        score: 0,
        gamesPlayed: 0,
        gamesWon: 0,
        lastLogin: new Date().toISOString()
      };
      
      // Save to local storage
      saveUser(userData);
      
      // Call the onUserLogin callback if provided
      if (onUserLogin) {
        onUserLogin(userData);
      }
      
      // Navigate to the game
      navigate('/game');
    } catch (error) {
      console.error('Error during login:', error);
      setError('An error occurred during login. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-hero">
        <div className="login-logo">
          <h1>Hangman</h1>
          <p className="login-tagline">The classic word guessing game</p>
        </div>
        <ThemeToggle />
      </div>
      
      <div className="login-card">
        <h2 className="login-subtitle">Enter your details to play</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="country">Country</label>
            <CountryAutocomplete 
              value={country} 
              onChange={setCountry} 
              id="country" 
              placeholder="Select your country"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="twitter">Twitter Username</label>
            <div className="twitter-input-container">
              <span className="twitter-at">@</span>
              <input
                type="text"
                value={twitterUsername}
                onChange={(e) => setTwitterUsername(e.target.value)}
                id="twitter"
                placeholder="username"
                className="twitter-input"
                required
              />
            </div>
          </div>
          
          <button 
            type="submit" 
            className="login-button" 
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Play Now'}
          </button>
        </form>
        
        <div className="game-info">
          <h3>How to Play</h3>
          <ul>
            <li>Try to guess the hidden word by selecting letters</li>
            <li>Each wrong guess adds a part to the hangman</li>
            <li>You can make 6 mistakes before losing</li>
            <li>Earn points for each correct word</li>
            <li>Compete with players worldwide</li>
          </ul>
        </div>
      </div>
      
      <div className="login-footer">
        <p>&copy; {new Date().getFullYear()} Hangman Game</p>
      </div>
    </div>
  );
};

export default Login; 